<template lang="pug">
    footer(:class="{black: isBlack}")
        .container
            .copy
                i18n(path="hf.copy")
                    br(place="break")
            app-header(:class="{black: isBlack}")
</template>

<script>
    import Header from "./Header";
    export default {
        name: "Footer",
        props:['isBlack'],
        components: {appHeader : Header}
    }
</script>

<style scoped lang="scss">
    footer{
        padding: 4rem 0;
        &.black{
            background: #fff;
            color: #000;
        }
    }
    .container{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .copy{
        font-size: 1.25rem;
        line-height: 1.4;
    }
    header{
        position: static;
        width: auto;
        padding-top: 0;
        &::v-deep{
            .dropdown{
                display: none;
            }
        }
    }
    @include mobile_or_P{
        footer{
            display: none;
        }
    }
</style>
